import { useModalForm } from '@/shared/hooks/useModalForm';

export interface PhoneData {
  phoneType: string;
  phone: string;
}

export interface ProponentFormData {
  email?: string;
  document?: string;
  phones: PhoneData[];
  name: string;
}

interface UseProponentModalProps {
  onClose: () => void;
  onSubmit: (data: ProponentFormData) => void;
}

export function useProponentModal({ onSubmit, onClose }: UseProponentModalProps) {
  const { form, handleFormSubmit } = useModalForm<ProponentFormData>({
    onSubmit: async (values) => {
      const formData: ProponentFormData = {
        name: values.name,
        document: values.document ?? '',
        email: values.email ?? '',
        phones: values.phones ?? [],
      };
      onSubmit(formData);
    },
    onClose,
    errorMessage: 'Erro ao adicionar proponente',
  });

  return {
    form,
    handleFormSubmit,
  };
}
